import React from "react";
import { error } from "common/constants";

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    errorMessage: null,
  };

  static getDerivedStateFromError(err) {
    return { hasError: true, errorMessage: err?.message || null };
  }

  componentDidCatch(err, errorInfo) {
    // Log the full error so we can see it in Netlify function logs / browser console
    console.error("[ErrorBoundary] Caught error:", err, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center", fontFamily: "sans-serif" }}>
          <h2 style={{ color: "#101828" }}>{error.errorBoundry}</h2>
          <p style={{ color: "#6b7280", marginBottom: 24 }}>
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 24px",
              background: "#2563EB",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 15,
              marginRight: 12,
            }}
          >
            Reload page
          </button>
          <a
            href="/"
            style={{ color: "#2563EB", fontSize: 14 }}
          >
            Go to home
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}
export default ErrorBoundary;
